// studentSubscriptionHelper.js

export const calculateGuestExpiration = (type) => {
  const date = new Date();
  if (type === 'monthly') {
    date.setMonth(date.getMonth() + 1);
  } else if (type === 'semi') {
    date.setMonth(date.getMonth() + 6);
  } else {
    date.setFullYear(date.getFullYear() + 1);
  }
  return date;
};
